/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_SubtitleInputs */

const cs_messages_subtitle = /** @type {(inputs: Messages_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpovědi z inzerátů na portálech, oddělené po dlaždicích.`)
};

const en_messages_subtitle = /** @type {(inputs: Messages_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing replies from portals, kept in separate tiles so they do not mix.`)
};

/**
* | output |
* | --- |
* | "Listing replies from portals, kept in separate tiles so they do not mix." |
*
* @param {Messages_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_subtitle = /** @type {((inputs?: Messages_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_subtitle(inputs)
	return cs_messages_subtitle(inputs)
});